<template>
  <div
    v-if="$store.getters.isLoggedIn"
    id="blog"
    class="page">
    <!-- Drawer -->
    <v-navigation-drawer
      v-model="isDrawerOpen"
      width="250px"
      mobile-break-point="0"
      floating
      app>
      <div class="h-100 d-flex flex-column page-drawer">
        <div class="page-logo-container mx-auto my-5">
          <!-- DelMar Logo -->
          <router-link
            id="logo"
            to="/content">
            <img
              src="../assets/img/logo.png"
            />
          </router-link>
          <!-- / DelMar Logo -->
        </div>

        <div class="page-navigation-container d-flex flex-column flex-grow-1">
          <!-- Main Navigation -->
          <MainNavigation />
          <!-- / Main Navigation -->

          <div class="mx-5 my-5 pb-5">
            <v-btn
              @click="$router.push({ name: 'BlogCreate' })"
              color="primary"
              type="button"
              block>
              <v-icon size="12">mdi-plus</v-icon>
              Add Blog
            </v-btn>
          </div>
        </div>

        <!-- User Account Menu -->
        <UserMenu class="mt-auto" />
        <!-- User Account Menu -->
      </div>
    </v-navigation-drawer>
    <!-- / Drawer -->

    <!-- Blog Page Content -->
    <v-content class="h-100">
      <v-toolbar
        class="my-2 page-toolbar">
        <v-app-bar-nav-icon
          class="page-drawer-toggle"
          @click="isDrawerOpen = !isDrawerOpen">
        </v-app-bar-nav-icon>

        <v-toolbar-title
          class="pl-0">
          <h4 class="d-flex align-center margin-right">
            {{$store.state.user.projectName}}
          </h4>
        </v-toolbar-title>

        <!-- Page Filter -->
        <div
          class="page-filter">
          <v-text-field
            prepend-inner-icon="mdi-magnify"
            clearable
            outlined
            filled
            hide-details
            v-model="blogFilter">
          </v-text-field>
        </div>
        <!-- / Page Filter -->

        <!-- Preview / Publish -->
          <PreviewPublish />
        <!-- / Preview / Publish -->
      </v-toolbar>

      <v-divider class="mx-5"></v-divider>

      <!-- Blog List -->
      <BlogList :blogPosts="blogPosts" />
      <!-- / Blog List -->
    </v-content>
    <!-- / Blog Page Content -->
  </div>
</template>

<script>
import _ from 'lodash';
import MainNavigation from '../components/MainNavigation.vue';
import PreviewPublish from '../components/PreviewPublish.vue';
import UserMenu from '../components/UserMenu.vue';
import BlogList from '../components/BlogList.vue';

export default {
  name: 'Blog',
  components: {
    MainNavigation,
    PreviewPublish,
    UserMenu,
    BlogList,
  },
  data() {
    return {
      isDrawerOpen: true,
      blogFilter: '',
    };
  },
  computed: {
    blogPosts() {
      return _.filter(
        this.$store.state.blogs,
        (blog) => {
          const blogFilter = this.blogFilter.toLowerCase();
          let blogTextContent = document.createElement('span');

          blogTextContent.innerHTML = blog.content;
          blogTextContent = blogTextContent.textContent || blogTextContent.innerText;

          const titleMatch = blog.title.includes(blogFilter);
          const contentMatch = blogTextContent.toLowerCase().includes(blogFilter);

          return !blogFilter || titleMatch || contentMatch;
        },
      );
    },
  },
};
</script>

<style lang="scss"></style>
